import {InputTextV2} from '@prtimes-basis/input';
import {
  type ChangeEvent,
  type Dispatch,
  type SetStateAction,
  useEffect,
  useState,
} from 'react';
import {useController} from 'react-hook-form';
import styles from './fax-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';
import {useCompanyRegistrationFormContext} from '@/features/company-registration/form';

const faxFieldName = 'contactPersonInfo.fax';

export function FaxField() {
  return (
    <FormField.Root name={faxFieldName}>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {getValues} = useCompanyRegistrationFormContext();
  const faxValue = getValues(faxFieldName);
  const [firstField, setFirstField] = useState(() => faxValue.split('-')[0]);
  const [secondField, setSecondField] = useState(
    () => faxValue.split('-')[1] || '',
  );
  const [thirdField, setThirdField] = useState(
    () => faxValue.split('-')[2] || '',
  );

  const {
    control,
    fieldProps: {name},
    isError,
  } = useFormField();
  const {field} = useController({control, name});

  const onChange = (
    {target: {value}}: ChangeEvent<HTMLInputElement>,
    setStateFunction: Dispatch<SetStateAction<string>>,
  ) => {
    // 4桁以上は入力できない
    if (value.length > 4) return;

    setStateFunction(value);
  };

  // フォームに同期するエフェクト
  useEffect(() => {
    if (!firstField.trim() && !secondField.trim() && !thirdField.trim()) {
      field.onChange('');
      return;
    }

    field.onChange(
      `${firstField.trim()}-${secondField.trim()}-${thirdField.trim()}`,
    );
  }, [field, firstField, secondField, thirdField]);

  return (
    <div className={companyRegistrationPageStyles.phoneNumberField}>
      <InputTextV2
        ref={field.ref}
        required
        wrapperClassName={styles.input}
        value={firstField}
        error={isError}
        aria-invalid={isError}
        aria-describedby={`${field.name}-error`}
        aria-label='FAX'
        onChange={(event) => {
          onChange(event, setFirstField);
        }}
      />
      <p
        role='presentation none'
        className={companyRegistrationPageStyles.presentation}
      >
        -
      </p>
      <InputTextV2
        required
        wrapperClassName={styles.input}
        value={secondField}
        error={isError}
        aria-invalid={isError}
        aria-describedby={`${field.name}-error`}
        aria-label='FAX'
        onChange={(event) => {
          onChange(event, setSecondField);
        }}
      />
      <p
        role='presentation none'
        className={companyRegistrationPageStyles.presentation}
      >
        -
      </p>
      <InputTextV2
        required
        wrapperClassName={styles.input}
        value={thirdField}
        error={isError}
        aria-invalid={isError}
        aria-describedby={`${field.name}-error`}
        aria-label='FAX'
        onChange={(event) => {
          onChange(event, setThirdField);
        }}
      />
    </div>
  );
}
